import { jsx as _jsx } from "react/jsx-runtime";
export function SubText(props) {
    const { error, help, valid: validProps } = props;
    const valid = typeof validProps === 'string' ? validProps : undefined;
    const text = error || valid || help;
    return _jsx("p", { style: { color: getColor(error, validProps) }, children: text });
}
function getColor(error, valid) {
    if (error) {
        return '#f95d55';
    }
    if (valid && typeof valid !== 'boolean') {
        return '#62cb21';
    }
    return 'gray';
}
//# sourceMappingURL=SubText.js.map